import { useMutation } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useChangeStatusConnect = () => {
  const mutation = useMutation({
    mutationFn: ({ connectId, active }: { connectId: number; active: boolean }) =>
      connectService.changeStatusConnect(connectId, active)
  });

  return { changeStatusConnect: mutation.mutateAsync, isChangingStatus: mutation.isPending, error: mutation.error };
};
